import { Loader2 } from "lucide-react";
import SignUpForm from "@/components/forms/SignUpForm";
import { motion } from "framer-motion";
import AuthDisplay from "./components/AuthDisplay";
import HelmetMetaData from "@/components/HelmetMetaData";
import { cn } from "@/lib/utils";
import { useMediaQuery } from "react-responsive";
import { FcGoogle } from "react-icons/fc";
import { useEffect, useLayoutEffect, useState } from "react";
import { SocialLogin } from "@capgo/capacitor-social-login";
import { PostRequest } from "@/lib/http";
import { toast } from "sonner";
import { useDispatch } from "react-redux";
import { loginUser } from "@/redux/userReducer";
import { useNavigate } from "react-router-dom";


const Signup = () => {
  const smallerScreen = useMediaQuery({ query: "(max-width: 380px)" });
  const [open, setOpen] = useState(true);
  const [googleLoading, setGoogleLoading] = useState(false);
  const dispatch = useDispatch()
  const navigate = useNavigate()


  useLayoutEffect(() => {
    if (open) {
      setOpen(true);
    }
  }, [open]);

  const googleSignIn = async () => {
    try {
      setGoogleLoading(true);
      const res = await SocialLogin.login({
        provider: "google",
        options: {},
      });

      // handle the response
      const body = res.result?.profile;
      if (body) {
        //TODO: Send the data
        const { data, err } = await PostRequest({
          url: "/api/google-login",
          body,
          setState: setGoogleLoading,
        });
        if (!err) {
          localStorage.setItem("user-token", data?.token);
          dispatch(loginUser(data?.user));
          navigate("/dashboard");
        } else {
          toast.error("Login Error", {
            description: err,
          });
        }
      }
    } catch (error) {
      console.error("Google Sign-In Error:", error);
    } finally {
      setGoogleLoading(false);
    }
  };

  useEffect(() => {
    SocialLogin.initialize({
      google: {
        webClientId:
          "454824576589-kt773ve6thmbccf5kt9ut0a4hc9kigqo.apps.googleusercontent.com",
      },
    });
  }, []);

  return (
    <>
      <HelmetMetaData
        title="Register - Join Billzpay for Seamless Payments"
        description="Join Billzpay and simplify your payments. Enjoy instant airtime recharges, data bundle purchases, cable TV subscriptions, and utility bill payments. Benefit from unbeatable discounts, fast transactions, and 24/7 support. Sign up today and experience hassle-free payments!"
      />

      <section
        style={{
          background:
            "linear-gradient(135deg, #223867 0%, #33559b 50%, #111c34 100%)",
        }}
        className="h-full md:h-dvh lg:overflow-y-hidden"
      >
        <div className="flex h-full w-full items-center justify-center border-white/10 lg:flex-row lg:justify-start lg:rounded-2xl lg:border">
          <div className="dark:bg-darkBg relative h-full w-full overflow-hidden rounded-none bg-white p-4 md:h-[650px] md:w-[450px] lg:h-full lg:w-[40%] lg:px-10">
            {/* <img
              src="/logo.svg"
              alt="billzpay-logo"
              className="absolute top-3 right-3 w-12 lg:w-14"
            /> */}

            <div className="flex h-full w-full items-center">
              <div className="w-full rounded-3xl py-10 xl:p-10 xl:shadow-2xl">
                <motion.h2
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                  className={cn(
                    "font-archivo mb-2 text-[2.4rem] leading-[1.2] font-semibold text-black/85 lg:text-[2.3rem] dark:text-white",
                    smallerScreen && "text-[2rem] leading-[1]",
                  )}
                >
                  Get Started with Billzpay
                </motion.h2>

                <motion.p
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
                  className="leading-[1.3] text-gray-500 dark:text-gray-300"
                >
                  Create your account to get started with Billzpay
                </motion.p>

                <button
                  className="dark:bg-darkInput mt-4 flex w-full cursor-pointer items-center justify-center gap-2 rounded-md border border-gray-300 bg-white px-8 py-2.5 text-sm font-medium text-gray-700 transition-all duration-150 hover:bg-gray-100 dark:border-gray-600 dark:text-gray-100 dark:hover:bg-gray-800"
                  disabled={googleLoading}
                  // href="https://backend-new.billzpay.com.ng/google/login"
                  onClick={googleSignIn}
                >
                  {googleLoading ? (
                    <Loader2 className="animate-spin" size={20} />
                  ) : (
                    <FcGoogle size={20} />
                  )}
                  Continue with Google
                </button>

                <div className="my-4 flex items-center gap-3">
                  <div className="h-[1px] w-full bg-gray-300 dark:bg-gray-600"></div>
                  <span className="text-sm font-medium text-gray-500 dark:text-gray-400">
                    OR
                  </span>
                  <div className="h-[1px] w-full bg-gray-300 dark:bg-gray-600"></div>
                </div>

                <SignUpForm />
              </div>
            </div>
          </div>

          <AuthDisplay />
        </div>
      </section>

      {/**<ImageAds open={open} onOpenChange={() => setOpen(!open)} />**/}
    </>
  );
};

export default Signup;
